module.exports = __webpack_public_path__ + "img/checked-cross.4a4e40da.svg";